import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';

const MySwal = withReactContent(Swal);

const isMobile = () => window.innerWidth <= 768;

export function sweetAlert(options = {}) {
  const { title, text, icon = 'info', position, width, ...rest } = options;
  const mobile = isMobile();
  return MySwal.fire({
    title,
    text,
    icon,
    ...rest,
    width: mobile ? '100%' : width,
    position: mobile ? 'bottom' : (position || 'center'),
  });
}
